import React from "react";
import { View, Text, TextInput, Button } from "ui";

import { userMutations, authMutations } from "api";
import { notify } from "shared/services";
import { DataProps } from "types";
import { styled } from "styles";
import { AddContact } from "components";

export default class Settings extends React.Component<DataProps> {
  public state = {
    newPhone: "",
    newEmail: "",
    oldPass: "",
    newPass: "",
    confirmNewPass: "",
    confirmPhone: "",
    confirmEmail: ""
  };

  public render = () => {
    const { currentUser } = this.props;
    const { newPhone, newEmail, oldPass, newPass, confirmNewPass } = this.state;
    const { primary_email_id, primary_phone_id } = currentUser;
    return (
      <View flexDirection="column" p={2}>
        <View flexDirection="column">
          <Text mb={2} fontSize={4}>
            Telefoane
          </Text>
          {currentUser.phones.map(phone => (
            <AddContact
              confirmPhone={!phone.active}
              id={phone.id}
              title={phone.phone_number}
              rightText={
                phone.id === primary_phone_id ? "Principal" : undefined
              }
              isPhone={true}
            />
          ))}
          <View mt={1} flexDirection="row">
            <userMutations.AddPhone>
              {addPhone => (
                <ImputForm
                  onSubmit={async e => {
                    try {
                      e.preventDefault();
                      let phone = newPhone;
                      await addPhone({
                        variables: { phone }
                      });
                      this.setState({ newPhone: "" });
                      notify("Vei primi pe acest telefon un cod de activare in urmatoarele minute.");
                    } catch (ex) {}
                  }}
                >
                  <View
                    justifyContent="space-between"
                    flexDirection="row"
                    alignItems="stretch"
                  >
                    <TextInput
                      height="2rem"
                      value={newPhone}
                      onChange={e =>
                        this.setState({ newPhone: e.target.value })
                      }
                      flex={2}
                      mr={2}
                      pl={3}
                      placeholder="Adauga numar de telefon."
                    />
                    <Button
                      px={2}
                      p={1}
                      as="button"
                      type="submit"
                      border="none"
                    >
                      <Text color="white" fontWeight="bold" fontSize={5}>
                        +
                      </Text>
                    </Button>
                  </View>
                </ImputForm>
              )}
            </userMutations.AddPhone>
          </View>
        </View>
        <View mt={4} flexDirection="column">
          <Text mb={2} fontSize={4}>
            Adrese de e-mail
          </Text>
          {currentUser.emails.map(email => (
            <AddContact
              confirmEmail={!email.active}
              id={email.id}
              title={email.email}
              rightText={email.id === primary_email_id ? "Principal" : ""}
              isEmail={true}
            />
          ))}
          <View mt={1} flexDirection="row">
            <userMutations.AddEmail>
              {addEmail => (
                <ImputForm
                  onSubmit={async e => {
                    try {
                      e.preventDefault();
                      let email = newEmail;
                      await addEmail({
                        variables: { email }
                      });
                      this.setState({ newEmail: "" });
                      notify("Vei primi pe acest email un cod de activare in urmatoarele minute.");
                    } catch (ex) {}
                  }}
                >
                  <View
                    justifyContent="space-between"
                    flexDirection="row"
                    alignItems="stretch"
                  >
                    <TextInput
                      height="2rem"
                      value={newEmail}
                      onChange={e =>
                        this.setState({ newEmail: e.target.value })
                      }
                      flex={2}
                      mr={2}
                      pl={3}
                      placeholder="Adauga adresa de e-mail"
                    />
                    <Button
                      px={2}
                      p={1}
                      as="button"
                      type="submit"
                      border="none"
                    >
                      <Text color="white" fontWeight="bold" fontSize={5}>
                        +
                      </Text>
                    </Button>
                  </View>
                </ImputForm>
              )}
            </userMutations.AddEmail>
          </View>
        </View>

        <authMutations.ChangePassword>
          {changePassword => (
            <ImputForm
              onSubmit={async e => {
                e.preventDefault();
                try {
                  await changePassword({
                    variables: {
                      oldPassword: oldPass,
                      newPassword: newPass,
                      confirmNewPassword: confirmNewPass
                    }
                  });
                  this.setState({
                    oldPass: "",
                    newPass: "",
                    confirmNewPass: "",
                  });
                  notify("Parola a fost schimbata.");
                } catch (ex) {}
              }}
            >
              <View mt={4} flexDirection="column">
                <Text mb={2} fontSize={4}>
                  {" "}
                  Schimbare Parola{" "}
                </Text>
                <TextInput
                  height="2rem"
                  type="password"
                  value={oldPass}
                  onChange={e => this.setState({ oldPass: e.target.value })}
                  mt={1}
                  mb={1}
                  pl={3}
                  placeholder="Vechea Parola"
                />
                <TextInput
                  height="2rem"
                  type="password"
                  value={newPass}
                  onChange={e => this.setState({ newPass: e.target.value })}
                  mt={1}
                  mb={1}
                  pl={3}
                  placeholder="Noua Parola (min. 6 caractere)"
                />
                <TextInput
                  height="2rem"
                  type="password"
                  value={confirmNewPass}
                  onChange={e =>
                    this.setState({ confirmNewPass: e.target.value })
                  }
                  mt={1}
                  mb={2}
                  pl={3}
                  placeholder="Repeta Noua Parola (min. 6 caractere)"
                />
                <Button as="button" type="submit" border="none">
                  <Text color="white" fontSize={3}>
                    Schimba Parola
                  </Text>
                </Button>
              </View>
            </ImputForm>
          )}
        </authMutations.ChangePassword>
      </View>
    );
  }
}

const ImputForm = styled.form`
  width: 100%;
`;



// WEBPACK FOOTER //
// ./src/pages/Settings.tsx